// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"eq","pgUseBox":"eq","use-card-wrap":"er","useCardWrap":"er","use-box-wrap":"es","useBoxWrap":"es"};